import React from 'react';
import './TextAreaField.css';

function TextAreaField({fieldConfig, value, showValidationError, onFieldUpdate, hide = false}) {
    const errorMsg = value ? fieldConfig.errorMinMsg : fieldConfig.errorMsg;
    const maxLength = 500;

    return (
            !hide && (
                    <label className={`TextAreaField-label${showValidationError ? ' TextAreaField-label--error' : ''}`}>
                        <span className="TextAreaField-title">{fieldConfig.label}</span>
                        <div className="TextAreaField-field-box">
                    <textarea
                            rows="3"
                            maxLength={maxLength}
                            placeholder={fieldConfig.placeholder}
                            className="TextAreaField-input"
                            onChange={(event) => {
                                onFieldUpdate(event.target.value);
                            }}
                            value={value}
                    />
                            <p className="TextAreaField-char-counter">
                                {fieldConfig.charsLeftMsg} <span>{maxLength - value.length}</span>
                            </p>
                        </div>
                        <span className="TextAreaField-error-msg">{errorMsg}</span>
                    </label>
            )
    );
}

export default TextAreaField;



// WEBPACK FOOTER //
// ./src/components/Form/TextAreaField.js